import { FC } from "react";
import { Link } from "react-router-dom";

import CustomPieChart from "../customPieChart";
import { objectToQueryString } from "src/helpers";

import { AreaCaseBySubmissionProps } from "../caseVolumeLineChart/types";



const CustomComponentAreaCaseBySubmission: FC<AreaCaseBySubmissionProps> = ({ StatisticsObjectType ,title, queryParams, isFilterObjUpdated }): JSX.Element => {

  const findPath = () => {
    if(title === "Area Managers"){
      return '/regions'
    }else if(title === "Regional Managers"){
      return '/districts'
    }else if(title === "District Managers" || title === "Rep"){
      return '/territories'
    }else if(title === "Practices"){
      return '/practice_stats'
    }else if (title === "Doctors"){
      return "/doctor_stats"
    }
  }

  return (
    <div className="row">
      <div className="col-12 col-lg-6 d-flex">
        <div className="card flex-fill mt-3">
          <div className="card-header">
            <h2 className="m-0 text-center text-primary">{title}
            </h2>
          </div>
          <div className="card-body overflow-auto p-0" style={{maxHeight: '550px'}}>
            <table className="table table-responsive table-hover" >
              <thead className="table-light">
                <tr className="text-center">
                  <th>Name</th>
                  <th>Cases</th>
                </tr>
              </thead>
              <tbody>
                {StatisticsObjectType.territories && StatisticsObjectType.territories.data && StatisticsObjectType.territories.data.length > 0 &&
                  StatisticsObjectType.territories.data.map((item, key) =>
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: findPath(),
                            search: objectToQueryString({
                              ...(isFilterObjUpdated() ? queryParams : {}),
                              id: JSON.stringify(item.id), role: item.role
                            })
                          }}
                          className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                        >{item?.name}</Link>
                      </td>
                      <td>{item?.cases}</td>
                    </tr>
                  )
                }
              </tbody>
              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{StatisticsObjectType?.territories?.case_total}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6">
        <CustomPieChart
          title={"Cases By Submission Mode"} 
          pieChartObject={
            StatisticsObjectType.mos
              .sort((item, item1) => {
                const nameOne = item.name ?? ""
                const nameTwo = item1.name ?? ""
                return nameOne > nameTwo ? 1 : -1
              })
          }
        />
      </div>
    </div>
  );
};

export default CustomComponentAreaCaseBySubmission;
